import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { format } from 'date-fns';
import Button from 'components/Button';
import TripActions from 'store/ducks/trip';
import ModalSelecionarViagem from '../Cte/ModalSelecionarViagem';
import Section from '../../components/Section';
import CustomTable from '../../components/CustomTable';
import {
  Container,
  Content,
  Row,
  WrapperTable,
  ItemTable,
  DeleteIcon,
  Error,
} from '../Cte/styles';

function DeliveryPoint({ formik, invoices, setInvoices, edit, view }) {
  const dispatch = useDispatch();
  const [modalViagemOpen, setModalViagemOpen] = useState(false);

  useEffect(() => {
    // Buscar apenas viagens sem carga (sem carga_id)
    dispatch(TripActions.getViagensRequest({ sem_carga: true }));
  }, [dispatch]);

  const handleSelectViagem = (viagem) => {
    if (viagem) {
      // Adicionar a viagem selecionada à lista
      const existingViagens = formik.values.delivery_viagens || [];
      
      // Verificar se a viagem já não foi adicionada (evitar duplicatas)
      const exists = existingViagens.some(
        (v) => v.id === viagem.id
      );

      if (!exists) {
        const updatedViagens = [
          ...existingViagens,
          {
            id: viagem.id,
            referencia: viagem.referencia || '-',
            data_emissao: viagem.data_emissao || '-',
            valor: viagem.transporte?.valor_servico || viagem.transporte?.valor_carga || 0,
            invoices_count: viagem.invoices?.length || 0,
          },
        ];
        formik.setFieldValue('delivery_viagens', updatedViagens);
        formik.values.delivery_viagens = updatedViagens;
      }
    }
  };

  const handleDeleteViagem = (viagemId) => {
    const viagens = formik.values.delivery_viagens || [];
    const updatedViagens = viagens.filter((v) => v.id !== viagemId);
    formik.setFieldValue('delivery_viagens', updatedViagens);
    formik.values.delivery_viagens = updatedViagens;
  };

  const tableData =
    formik.values.delivery_viagens && formik.values.delivery_viagens.length > 0
      ? formik.values.delivery_viagens.map((viagem) => ({
          id: viagem.id,
          referencia: viagem.referencia,
          data_emissao: viagem.data_emissao && viagem.data_emissao !== '-'
            ? format(new Date(viagem.data_emissao), 'dd/MM/yyyy')
            : '-',
          valor: viagem.valor,
          invoices_count: viagem.invoices_count,
        }))
      : [];

  return (
    <Section
      title="Locais de Entrega"
      rightContent={
        <Button
          label="Carregar Viagens Cadastradas"
          onClick={() => setModalViagemOpen(true)}
          color="primary"
          width="250px"
          height="40px"
        />
      }
    >
      <Container>
        <Content>
          <Row>
            <WrapperTable>
              <CustomTable
                columns={[
                  { label: 'ID', id: 'id' },
                  { label: 'Referência', id: 'referencia' },
                  { label: 'Data de Emissão', id: 'data_emissao' },
                  { label: 'Valor', id: 'valor' },
                  { label: 'Nº de Notas', id: 'invoices_count' },
                  { label: 'Ações', id: 'actions' },
                ]}
                activePage={0}
                totalPages={1}
                data={tableData}
                styleCell={{ flex: 1, alignContent: 'space-between' }}
                customComponent={{
                  valor: (e) =>
                    e.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }),
                  data_emissao: (e) => e,
                  actions: (e, item) => (
                    <ItemTable>
                      <DeleteIcon
                        onClick={() => handleDeleteViagem(item.id)}
                      />
                    </ItemTable>
                  ),
                }}
              />
            </WrapperTable>
            {formik.errors.delivery_viagens && (
              <Error>{formik.errors.delivery_viagens}</Error>
            )}
          </Row>
        </Content>
      </Container>
      <ModalSelecionarViagem
        open={modalViagemOpen}
        onClose={() => setModalViagemOpen(false)}
        onSelect={handleSelectViagem}
      />
    </Section>
  );
}

export default DeliveryPoint;
